// tslint:disable-next-line: no-submodule-imports
import "bootstrap/dist/css/bootstrap.css";
import React from "react";
import { hydrate, render } from "react-dom";
import ReactGA from "react-ga";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import * as serviceWorker from "./registerServiceWorker";
import store, { persistor } from "./store";

if (process.env.NODE_ENV === "production") {
  ReactGA.initialize("UA-44297367-2");
} else {
  ReactGA.initialize("UA-44297367-2", { debug: true, testMode: true });
  // tslint:disable-next-line: no-console
  console.log("GA initialized with testMode");
}
ReactGA.pageview(window.location.pathname + window.location.search);

const RootComponent = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);

const rootElement = document.getElementById("root");
if (rootElement && rootElement.hasChildNodes()) {
  hydrate(<RootComponent />, rootElement);
} else {
  render(<RootComponent />, rootElement);
}

serviceWorker.register();
